<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/businessNews/findBusinessNewsList.action"
                        ref="Table">
            <template slot="search">
                <el-row>
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item>
                            <el-select v-model="queryParams.status"  @change="$refs.Table.search()" placeholder="状态" :clearable="true" :filterable="true">
                                <el-option :value="1" label="已上架"></el-option>
                                <el-option :value="2" label="未上架"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="$refs.Table.search()" type="primary">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$router.push({path:'/home/saveBusinessNews'})">新增发布</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>

            </template>
            <template slot="item">
                <el-table-column
                        label="标题"
                        prop="title">
                </el-table-column>
                <el-table-column
                    label="url链接"
                    prop="link">
            </el-table-column>
                <el-table-column
                        label="广告位置"
                        prop="link">
                    <template scope="scope">
                        {{ scope.row.target|targetFilter }}
                    </template>
                </el-table-column>

                <el-table-column
                        label="小程序Appid"
                        prop="miniAppid">
                    <template scope="scope">
                        {{ scope.row.miniAppid}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="小程序Path"
                        prop="miniPath">
                    <template scope="scope">
                        {{ scope.row.miniPath}}
                    </template>
                </el-table-column>

                <el-table-column
                label="状态"
                prop="status">
                    <template scope="scope">
                        <span v-if="scope.row.status==1" style="color: red;">
                            已上架
                        </span>
                        <span v-if="scope.row.status==2" >
                            下架
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="300">
                    <template scope="scope">
                        <span style="margin-left: 10px;color:#909399;">{{scope.row.createTime|dateTimeFormat }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        label="操作" width="250px">
                    <template scope="scope" >
                        <el-button :type="scope.row.status==1?'success':'primary'"  size="small"  v-confirm :confirm-text="scope.row.status==1?'确认下架？':'确认上架？'"  requestUrl="businessNews/changeBusinessNewsStatus.action" :confirm-data="{id:scope.row.id,status:scope.row.status==1?2:1}" @onConfirm="$refs.Table.search()">{{scope.row.status==1?'下架':'上架'}}</el-button>
                        <el-button :type="success"  size="small"  v-confirm  requestUrl="businessNews/deleteNews.action" :confirm-data="{newsId:scope.row.id}" @onConfirm="$refs.Table.search()">删除</el-button>
                        <el-button type="warning"  size="small"  @click="$router.push({name:'编辑内网广告', params: { id: scope.row.id }})" >编辑 </el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'business-news',
  data: function () {
    return {
      queryParams: { status: 1 }
    }
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.Table.search()
    }
  },
  filters: {
    targetFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '首页banner'
          break
        case 2:
          str = '首页弹窗'
          break
        case 3:
          str = '详情弹窗'
          break
        case 4:
          str = '推广通banner'
          break
        case 5:
          str = '查行情banner'
          break
      }
      return str
    },
    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '上架'
          break
        case 2:
          str = '下架'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
